import { CommonModule } from "@angular/common";
import { Component } from "@angular/core";
import { RouterLink } from "@angular/router";
import { TranslateModule, TranslateService } from "@ngx-translate/core";

@Component({
  selector: 'privacy-policy-page-component',
  templateUrl: './privacy-policy-page.component.html',
  styleUrl: './privacy-policy-page.component.scss',
  imports: [
    CommonModule,
    TranslateModule
  ]
})
export class PrivacyPolicyPage {
  public lang: string | null = null;
  constructor(private translateService: TranslateService) {
    this.lang = this.translateService.currentLang;
  }
}